import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { YoutubeComponent} from "./components/youtube-component/youtube.component";
import { ChatComponent} from "./components/chat-component/chat.component";
import { JitsiComponent} from "./components/jitsi-component/jitsi.component";
import {TranslateModule} from "./translate-module";

import { CommonModule } from '@angular/common';
import {ComunicationSafePipe} from './components/comunication-safe-pipe';
import { FormsModule } from '@angular/forms';
@NgModule({
  declarations: [
    YoutubeComponent,
    ChatComponent,
    ComunicationSafePipe,
    JitsiComponent


  ],
  imports: [CommonModule,FormsModule,    TranslateModule],
  providers: [
  ],
  exports : [
    YoutubeComponent,
    ChatComponent,
    ComunicationSafePipe,
    JitsiComponent,


  ],
})
export class ComunicationModule { }




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/comunication-module.ts